import UnitFeatureSet from 'scripts/defa/unit-feature-sets/model-unit-feature-set';

/**
 * defa.collections.UnitFeatureSets
 * A collection of UnitFeatureSet objects
 * @version 0.9
 */
const UnitFeatureSets = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: UnitFeatureSet,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UnitFeatureSets;